// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bunny-player-wrapper[data-v-4c489d78]{display:flex}.video-container[data-v-4c489d78]{width:100%;aspect-ratio:16/9;background:#000;border-radius:4px;overflow:hidden}.video-container iframe[data-v-4c489d78]{border:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
